import { useState } from 'react';
import {
  DashboardFilterPillUIState,
  DashboardFilterPillsUIStateWithSetters,
} from './types';

export const getInitialDashboardFilterPillUIState =
  (): DashboardFilterPillUIState => ({
    isValuePopoverOpen: false,
    isOperatorPopoverOpen: false,
    popoverInputValue: null,
    showDatePicker: false,
  });

export const useDashboardFilterPillUIState = (
  filterIds: string[]
): Record<string, DashboardFilterPillsUIStateWithSetters> => {
  const [filterPillUIState, setFilterPillUIState] = useState<
    Record<string, DashboardFilterPillUIState>
  >({});

  const toggleIsValuePopoverOpen = (filterId: string) => {
    setFilterPillUIState(prevState => ({
      ...prevState,
      [filterId]: {
        ...prevState[filterId],
        isValuePopoverOpen: !prevState[filterId]?.isValuePopoverOpen,
      },
    }));
  };

  const toggleIsOperatorPopoverOpen = (filterId: string) => {
    setFilterPillUIState(prevState => ({
      ...prevState,
      [filterId]: {
        ...prevState[filterId],
        isOperatorPopoverOpen: !prevState[filterId]?.isOperatorPopoverOpen,
      },
    }));
  };

  const toggleShowDatePicker = (filterId: string) => {
    setFilterPillUIState(prevState => ({
      ...prevState,
      [filterId]: {
        ...prevState[filterId],
        showDatePicker: !prevState[filterId]?.showDatePicker,
      },
    }));
  };

  const setPopoverInputValue = (
    filterId: string,
    inputValue: string | number | null
  ) => {
    setFilterPillUIState(prevState => ({
      ...prevState,
      [filterId]: {
        ...prevState[filterId],
        popoverInputValue: inputValue,
      },
    }));
  };

  return Object.fromEntries(
    filterIds.map(filterId => [
      filterId,
      {
        ...(filterPillUIState[filterId] ??
          getInitialDashboardFilterPillUIState()),
        toggleIsOperatorPopoverOpen: () =>
          toggleIsOperatorPopoverOpen(filterId),
        toggleIsValuePopoverOpen: () => toggleIsValuePopoverOpen(filterId),
        toggleShowDatePicker: () => toggleShowDatePicker(filterId),
        setPopoverInputValue: (inputValue: string | number | null) =>
          setPopoverInputValue(filterId, inputValue),
      },
    ])
  );
};
